<template>
  <div class="tariffs-companies mt-60">
    <div id="franchises" class="text-medium">
      {{ content.blocks?.franchises.title }}
    </div>
    <client-only>
      <div class="tariffs-companies-wrapper flex flex-wrap">
        <vz-button
          large
          icon-right
          v-for="(item, index) in items"
          :key="index"
          icon-size=20
          target="_blank"
          :href="item.url"
          variant="primary"
          class="mr-20 mt-20"
          icon-name="arrow-right"
        >
          {{ item.title }}
        </vz-button>
      </div>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const content = await getPageContent('/tariffs')
const items = [
  {
    title: 'ООО "Дилижанс"',
    url: 'https://tcdiligans.ru'
  },
  {
    title: 'ООО "Севертранс ТЭК"',
    url: 'https://severtrans-spb.ru'
  },
  {
    title: 'ООО "ЮгТрансТЭК"',
    url: 'https://ugtrans-tk.ru'
  },
  {
    title: 'ООО "Транспортные Технологии"',
    url: 'https://t-technology.ru'
  }
]
</script>
